import { useEffect } from 'react';

import { useAnalyticsService } from '@/app/providers/analytics-service/hooks';

import { pageLoadEvent } from '@/shared/services/analytics/events/page-load-event';
import { sessionStartEvent } from '@/shared/services/analytics/events/session-start-event';
import { trackerAfterEvent } from '@/shared/services/analytics/events/tracker-after-event';
import { PROTOCOL } from '@/shared/services/analytics/types';
import { useStartappArgs } from '@/shared/store/tg-store/tg-store';

export const useSessionTracking = () => {
  const analyticsService = useAnalyticsService();
  const startAppArgs = useStartappArgs();

  useEffect(() => {
    analyticsService.send(pageLoadEvent());

    analyticsService.send(trackerAfterEvent(), PROTOCOL.HTTP);

    analyticsService.send(
      sessionStartEvent(startAppArgs?.src, {
        user_properties: { labels: startAppArgs?.labels },
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
